import React, { useState, useEffect } from 'react';

/**
 * Recibe los datos de ejecución de un plan de campo y los muestra en una tabla, con la posibilidad de reportar avance en la ejecución
 * @param {function} keyGen Función para generar llaves únicas y no tenr erorres de renderizado
 * @param {object} data Datos a mostrar en la tabla, resultados de al API de reporte de ejecución
 * @param {string} modo Modo de visualización, completo muestra los campos de plan y ejecutado
 * @param {function} reportarAvance Función para reportar el avance de la ejecución del plan de campo
 * @returns JSX.Element
 */
const ListaEjecucionPC = (p) => {
    const keyGen = p.keyGen ?? (() => { counter++; return counter; })
    const data = p.data ?? {};
    const modo = p.modo ?? "normal";
    const reportarAvance = p.reportarAvance ?? (() => { });
    const dias = ['lunes', 'martes', 'miercoles', 'jueves', 'viernes', 'sabado'];
    const totales = p.totales ?? {};
    var counter = 0;
    useEffect(() => { }, [p.data]);

    return (
        <div className='w-100 round-s p-1 shadw bg-white shadow-multi overflow' style={{ maxHeight: "76vh" }}>
            <table className='table table-sm table-bordered table-hover'>
                <thead>
                    <tr className='text-s text-center'>
                        <th scope='col' className='bg-black text-white nowrap'>BLOQUE</th>
                        <th scope='col' className='bg-black text-white nowrap'>S. TRASP.</th>
                        <th scope='col' className='bg-black text-white nowrap'>RANCHO</th>
                        <th scope='col' className='bg-black text-white nowrap'>VALVULA</th>
                        <th scope='col' className='bg-black text-white nowrap'>CAMA INI</th>
                        <th scope='col' className='bg-black text-white nowrap'>CAMA FIN</th>
                        {
                            modo === 'completo' && <>
                                <th scope='col' className='bg-black text-white nowrap'>PLAN</th>
                                <th scope='col' className='bg-black text-white nowrap'>EJECUTADO</th>
                                <th scope='col' className='bg-black text-white nowrap'>DIFF</th>

                            </>}

                        {dias.map((d, i) => <th key={keyGen()} scope='col' className='bg-black text-white nowrap'>{d.toUpperCase()}</th>)}
                    </tr>
                </thead>
                <tbody>
                    {data.map((d, i) =>
                        <tr key={keyGen()} className='text-center nowrap' id={'lista_normal' + i}>
                            <th scope='row' className='text-start'>{d.bloque}</th>
                            <td>{d.semana_trasplante}</td>
                            <td>{d.rancho}</td>
                            <td>{d.valvula}</td>
                            <td>{d.cama_inicio}</td>
                            <td>{d.cama_fin}</td>
                            {
                                modo === 'completo' && <>
                                    <td>{d.plantas_plan}</td>
                                    <td>{d.total_plantas_ejecutado}</td>
                                    <td className={`${d.porcentaje_ejecutado < 95 ? 'text-red2' : d.porcentaje_ejecutado < 100 ? 'text-green3' : 'text-blue3'}`}>{d.diferencia}</td>

                                </>}

                            {dias.map((dia, j) => <td key={keyGen()} className=''>
                                <div className='row justify-content-evenly w-100 m-0 p-0' style={{ minWidth: "120px", maxWidth: "130px" }}>
                                    <div className={'w-45 border-end contenedor text-s ' + (+d[dia + "_plan"] > 0 ? "text-bold" : "")}>{d[dia + "_plan"]}</div>
                                    <input
                                        type='number'
                                        value={d[dia + "_ejecutado"]}
                                        name={`${j + 1}`}
                                        onChange={(e) => reportarAvance(e.target.name, e.target.value, i)}
                                        className={'form-control form-control-sm w-55 text-center' + (+d[dia + "_ejecutado"] > 0 ? 'text-bold' : '')} />
                                </div>
                            </td>)}
                        </tr>
                    )}
                    <tr key={keyGen()} className='text-center nowrap' >
                        <th scope='row' className='text-start'></th>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        {
                            modo === 'completo' && <>
                                <td className='text-bold'>{totales.planeado}</td>
                                <td className='text-bold'>{totales.ejecutado}</td>
                                <td className={`text-bold ${totales.porcentaje_ejecutado < 95 ? 'text-red2' : totales.porcentaje_ejecutado < 100 ? 'text-green3' : 'text-blue3'}`}>{totales.diferencia}</td>

                            </>}

                        {dias.map((dia, j) => <td key={keyGen()} className=''>
                            <div className='row justify-content-evenly w-100 m-0 p-0' style={{ minWidth: "120px", maxWidth: "130px" }}>
                                <div className='w-45 border-end contenedor text-s text-bold'>{totales[dia + "_plan"]}</div>
                                <div className='w-55 border-end contenedor text-s text-bold'>{totales[dia + "_ejecutado"]}</div>
                            </div>
                        </td>)}
                    </tr>

                </tbody>
            </table>
        </div>
    )
}

export default ListaEjecucionPC;